var DefaultValueConverter = {

    convert: function (str, columnName) {
        if (Validator.isDateTime(str)) {
            return this.convertToDateTime(str);
        }

        if (Validator.isValidUrl(str)) {
            return '<a href="' + str + '" target="_blank">URL <i class="fa fa-map-marker"></i></a>';
        }

        if (isDoubleFormattable(columnName) == true && typeof (str) == typeof (0.00) && Number.isInteger(str) == false) {
            return this.convertToCulturedDouble(str);
        }

        return str;
    },

    convertToDateTime: function (str) {
        var pattern = /Date\(([^)]+)\)/;
        var results = pattern.exec(str);
        var dt = new Date(parseFloat(results[1]));
        return dt.toLocaleDateString();
    },

    convertByteToIcon: function (str) {

        return '<div class="text-center"><i class="fal ' + getIconClass(str) + ' ' + getColorClass(str) + '"></i></div>';

        //if (str == 1 ) {
        //    return '<div class="text-center"><i class="ion ion-checkmark text-success"><i></div>';
        //} else if (str == 0) {
        //    return '<div class="text-center"><i class="ion ion-close text-danger"><i></div>';
        //} else {
        //    return str;
        //}

        function getColorClass(str) {
            if (str == 1) {
                return 'text-success';
            } else if (str == 0) {
                return 'text-danger';
            } else {
                return '';
            }
        }

        function getIconClass(str) {
            if (str == 1) {
                return 'fa-check';
            } else if (str == 0) {
                return 'fa-times';
            } else {
                return '';
            }
        }

    },

    convertPassword: function (str) {
        password = "******";
        return password;
    },

    convertToCulturedDouble: function (str) {
        return jsUtils.data.formatInvariantDoubleToCulture(str);
    },

    convertUserFlagToString: function (str) {
        if (str == 1)
            return 'User';
        if (str == 2)
            return 'Admin';
        if (str == 4)
            return 'Superuser';
        return '';
    }

};

function isDoubleFormattable(columnName) {
    var unformattableColumns = getFormatIgnoreList();

    return $.inArray(columnName, unformattableColumns) === -1;

    function getFormatIgnoreList() {
        var list = new Array();
        list.push('Abgabeeinheit2Faktor');
        list.push('Einheit2UmFaktor');
        return list;
    }
}

globalThis.DefaultValueConverter = DefaultValueConverter;
